var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.67 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9e9e9e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Word_01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.63,4.62l-2.9-2.91A5.81,5.81,0,0,0,9.6,0H5.83A4.17,4.17,0,0,0,1.67,4.17V15.83A4.17,4.17,0,0,0,5.83,20h8.34a4.17,4.17,0,0,0,4.16-4.17V8.74A5.78,5.78,0,0,0,16.63,4.62ZM15.45,5.79a4.41,4.41,0,0,1,.68.88H12.51a.84.84,0,0,1-.83-.84V2.22a4.59,4.59,0,0,1,.87.67l2.9,2.91Zm1.22,10a2.51,2.51,0,0,1-2.5,2.5H5.83a2.51,2.51,0,0,1-2.5-2.5V4.17a2.51,2.51,0,0,1,2.5-2.5H10V5.83a2.51,2.51,0,0,0,2.5,2.5h4.15a2.82,2.82,0,0,1,0,.41ZM13.93,11l-1.18,4.72a1.21,1.21,0,0,1-2.29.15L10,14.75,9.54,15.9a1.18,1.18,0,0,1-1.11.76H8.34a1.2,1.2,0,0,1-1.09-.92L6.08,11a.81.81,0,0,1,.6-1,.83.83,0,0,1,1,.61L8.53,14l.7-1.78a.85.85,0,0,1,.78-.52.83.83,0,0,1,.77.52l.7,1.78.85-3.33a.83.83,0,0,1,1.61.39Z",
    transform: "translate(-1.67)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocicon);
export default __webpack_public_path__ + "static/media/docicon.0f2ab59cf56a33f91dc9e3cc174f196c.svg";
export { ForwardRef as ReactComponent };